import { Post } from "domain/infra/data/api";
import AuthConstants from "../../infra/data/authConstants";
import { RecuperarSenhaRequest } from "../../types/recuperarSenha/recuperarSenhaRequest";
import ValidationResult from "domain/types/global/validationResult";

export class RecuperarSenhaService {
  constructor() { }

  async enviarEmailRecuperacao(request: RecuperarSenhaRequest, dispatchName: string): Promise<ValidationResult | Error> {
      return await Post(AuthConstants.apiAuth.auth.enviarEmailRecuperacao, request, dispatchName);
  }
}